import {
  UNIT_DISPLAY_LABELS,
  getUnitDisplayLabel,
} from '../../../components/ProductInfo/helpers';
import { formatProductAttributeTitle } from '../../helpers/productAttributes';

const MEASUREMENT_UNIT_TYPES = Object.keys(UNIT_DISPLAY_LABELS);

/** Shopify volume units whose UPPERCASE form does not match PIM keys via toLowerCase. */
const SHOPIFY_TO_PIM_VOLUME_UNIT = {
  FLUID_OUNCES: 'us_fluid_ounces',
  PINTS: 'us_pints',
  QUARTS: 'us_quarts',
  GALLONS: 'us_gallons',
};

/**
 * Format publish-error fieldName for display (e.g. Snowboard_length → Snowboard length).
 * @param {string|null|undefined} fieldName
 * @returns {string|null|undefined}
 */
export function formatPublishErrorFieldName(fieldName) {
  if (fieldName == null || fieldName === '') {
    return fieldName;
  }

  return formatProductAttributeTitle(fieldName);
}

/**
 * Resolve Shopify UPPERCASE unit to a short display label via PIM unit keys.
 * @param {string} shopifyUnit
 * @returns {string}
 */
function formatMeasurementUnit(shopifyUnit) {
  const shopifyKey = String(shopifyUnit).toUpperCase();
  const unitKey = SHOPIFY_TO_PIM_VOLUME_UNIT[shopifyKey]
    || String(shopifyUnit).toLowerCase();
  const type = MEASUREMENT_UNIT_TYPES.find(
    (unitType) => UNIT_DISPLAY_LABELS[unitType][unitKey],
  );

  if (!type) {
    return unitKey;
  }

  return getUnitDisplayLabel(type, unitKey);
}

/**
 * Humanize structured Shopify-serialized JSON values for publish error UI.
 * Keeps unrecognized / invalid JSON as the original string.
 * @param {string|number|null|undefined} currentValue
 * @returns {string|null|undefined}
 */
export function formatPublishErrorValue(currentValue) {
  if (currentValue == null || currentValue === '') {
    return currentValue;
  }

  if (typeof currentValue !== 'string') {
    return String(currentValue);
  }

  let parsed;
  try {
    parsed = JSON.parse(currentValue);
  } catch {
    return currentValue;
  }

  if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) {
    return currentValue;
  }

  if (parsed.amount != null && parsed.currency_code != null) {
    return `${parsed.amount} ${parsed.currency_code}`;
  }

  if (
    parsed.value != null
    && parsed.scale_min != null
    && parsed.scale_max != null
  ) {
    return `${parsed.value}/${parsed.scale_max}`;
  }

  if (parsed.value != null && parsed.unit != null) {
    return `${parsed.value} ${formatMeasurementUnit(parsed.unit)}`;
  }

  return currentValue;
}
